import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { type ReactNode } from 'react';
import { PortalShell } from '@/components/shell/PortalShell';
import { useSession } from '@/lib/session';
import Launcher from '@/pages/Launcher';
import AppHost from '@/pages/AppHost';
import HmhWatchApp from '@/components/hmhwatch/HmhWatchApp';
import WwdApp from '@/components/wwd/WwdApp';
import MnaApp from '@/components/mna/MnaApp';
import FoundryUsage from '@/pages/FoundryUsage';
import Login from '@/pages/Login';
import NotFound from '@/pages/NotFound';

// Gate every portal route behind the shared cookie login: hmhintel.com -> /login -> launcher.
// Apps live at clean paths: dummy apps via AppHost (/wwd, /ma, ...); HMH Watch is re-hosted
// in-shell at /hmhwatch via the BFF proxy.
function RequireAuth({ children }: { children: ReactNode }) {
  const { data, isLoading } = useSession();
  const location = useLocation();
  if (isLoading) return <div className="p-8 text-muted">…</div>;
  if (!data?.authenticated) {
    const returnUrl = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnUrl=${returnUrl}`} replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <PortalShell>
                <Routes>
                  <Route index element={<Launcher />} />
                  <Route path="hmhwatch/*" element={<HmhWatchApp />} />
                  <Route path="wwd/*" element={<WwdApp />} />
                  <Route path="mna/*" element={<MnaApp />} />
                  <Route path="foundry-usage" element={<FoundryUsage />} />
                  <Route path=":slug" element={<AppHost />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </PortalShell>
            </RequireAuth>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}
